import { render, staticRenderFns } from "./TableSimple.vue?vue&type=template&id=720fd5a4&scoped=true&"
import script from "./TableSimple.vue?vue&type=script&lang=js&"
export * from "./TableSimple.vue?vue&type=script&lang=js&"
import style0 from "./TableSimple.vue?vue&type=style&index=0&id=720fd5a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720fd5a4",
  null
  
)

export default component.exports